module.exports = __webpack_public_path__ + "img/6.54d0124f.jpg";